import { upsellPageDataDbWriteValidator } from "@redotech/redo-model/upsell-page/upsell-page-db-validator";
import * as z from "zod/v4";

export const getActiveUpsellPageForTeam = {
  name: "getActiveUpsellPageForTeam" as const,
  input: z.null(),
  output: z
    .object({
      upsellPageId: z.string(),
      upsellPageData: upsellPageDataDbWriteValidator,
    })
    .nullable(),
};
